module.exports = __webpack_public_path__ + "static/media/forgot-password.d255e810.svg";